export default "__VITE_ASSET__SlwYndgL__"